import { styled } from "@mui/material/styles";

export const DEFAULT_HEIGHT = 560;
const MOBILE_HEIGHT = Math.ceil(260);

export enum Mode {
    SINGLE = "single",
    SPLIT_TO_2 = "split-to-2",
    SPLIT_TO_4 = "split-to-4",
}

export const ProductGalleryV2Wrapper = styled("div")(({ theme }) => ({
    display: "grid",
    position: "relative",
    boxSizing: "border-box",
    gap: theme.spacing(1),
    height: MOBILE_HEIGHT,
    gridTemplateAreas: '"first"',
    borderRadius: theme.roundness,
    '&[data-is-rounded="false"]': {
        borderRadius: 0,
    },

    overflow: "clip",
    gridTemplateRows: "100%",
    [theme.breakpoints.up("md")]: {
        height: "var(--product-gallery-height)",
        [`&[data-mode="${Mode.SPLIT_TO_2}"]`]: {
            gridTemplateAreas: '"first ." "first ."',
            gridTemplateColumns: "minmax(0, 60%) minmax(0, 40%)",
            gridTemplateRows: "minmax(0, 50%) minmax(0, 50%)",

            '[data-ref="image"]:nth-of-type(-n+3)': {
                display: "block",
            },
        },
        [`&[data-mode="${Mode.SPLIT_TO_4}"]`]: {
            gridTemplateAreas: '"first . ." "first . ."',
            gridTemplateColumns: "minmax(0, 50%) minmax(0, 25%) minmax(0, 25%)",
            gridTemplateRows: "minmax(0, 50%) minmax(0, 50%)",

            '[data-ref="image"]:nth-of-type(-n+5)': {
                display: "block",
            },
        },
    },
    '[data-ref="image"]': {
        display: "none",
        "&:first-of-type": {
            gridArea: "first",
            display: "block",
            height: "100%",
        },
    },
}));
